import { css } from '@emotion/css';

export const addMoreButtonOverrideStyles = css`
  padding-inline-start: 1.2rem;
  padding-inline-end: 0.8rem;

  .MuiButton-startIcon {
    display: none;
  }

  .MuiButton-endIcon {
    margin-inline-start: 0.4rem;
  }

  .arrow-icon {
    width: 1.6rem !important;
    height: 1.6rem !important;
  }

  .label {
    color: var(--text-paragraph) !important;
  }
`;
